import { FC } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
interface IProps {
    href?: string;
    hideMore?: boolean;
    isViewMore?: boolean;
    viewBtnText?: string;
    callback?: () => void;
}

const ViewMore: FC<IProps> = ({ href, hideMore, isViewMore, callback, viewBtnText }) => {
    const { t } = useLang('membersday.activity');

    const clickHandle = () => {
        callback && callback();
    };
    const btnText = () => {
        if (viewBtnText) return viewBtnText;

        if (isViewMore) {
            if (!hideMore) return t('view_more_btn_3');
            return t('view_more_btn_2');
        }
        return t('view_more_btn');
    };

    return (
        <div className={`${styled.content} members-ViewMore`} onClick={clickHandle}>
            <EditorLink
                href={href}
                className="view-more-btn"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: t('product_title3'),
                    position: 'EcoCredits day',
                }}
            >
                {btnText()}
                {!viewBtnText && (
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="Vector" d="M1 13L7 7L1 1" stroke="#FFBD3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                )}
            </EditorLink>
        </div>
    );
};

export default ViewMore;
